import { useEffect, useRef } from "react";
import type { SnoozePreset } from "../../lib/snooze";

export function MsgRowQuickActions({
  seen,
  snoozeOpen,
  snoozePresets,
  onArchive,
  onDelete,
  onMarkUnread,
  onToggleSnooze,
  onSnoozePick,
}: {
  seen: boolean;
  snoozeOpen: boolean;
  snoozePresets: SnoozePreset[];
  onArchive: () => void;
  onDelete: () => void;
  onMarkUnread: () => void;
  onToggleSnooze: () => void;
  onSnoozePick: (wakeAt: number) => void;
}) {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!snoozeOpen) return;
    function onDoc(e: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        onToggleSnooze();
      }
    }
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [snoozeOpen, onToggleSnooze]);

  return (
    <div className="msg-hover-actions" onClick={(e) => e.stopPropagation()}>
      <button type="button" className="msg-hover-btn" onClick={onArchive} title="Archivia">
        <span className="msg-hover-icon" aria-hidden>
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="M21 8v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8" />
            <path d="M1 4h22v4H1z" />
            <path d="M10 12h4" />
          </svg>
        </span>
        <span className="msg-hover-label">Archivia</span>
      </button>
      <button type="button" className="msg-hover-btn danger" onClick={onDelete} title="Elimina">
        <span className="msg-hover-icon" aria-hidden>
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="M3 6h18" />
            <path d="M8 6V4h8v2" />
            <path d="M19 6l-1 14H6L5 6" />
            <path d="M10 11v6" />
            <path d="M14 11v6" />
          </svg>
        </span>
        <span className="msg-hover-label">Elimina</span>
      </button>
      {seen ? (
        <button type="button" className="msg-hover-btn" onClick={onMarkUnread} title="Segna come da leggere">
          <span className="msg-hover-icon" aria-hidden>
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
              <rect x="3" y="5" width="18" height="14" rx="2" />
              <path d="M3 7l9 6 9-6" />
              <circle cx="18" cy="7" r="2.5" fill="currentColor" stroke="none" />
            </svg>
          </span>
          <span className="msg-hover-label">Da leggere</span>
        </button>
      ) : null}
      <div className="msg-hover-snooze-wrap" ref={menuRef}>
        <button
          type="button"
          className={`msg-hover-btn ${snoozeOpen ? "is-open" : ""}`}
          onClick={onToggleSnooze}
          title="Posticipa"
        >
          <span className="msg-hover-icon" aria-hidden>
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
              <circle cx="12" cy="13" r="8" />
              <path d="M12 9v4l2.5 1.5" />
              <path d="M9 2h6" />
              <path d="M12 2v2" />
            </svg>
          </span>
          <span className="msg-hover-label">Posticipa</span>
        </button>
        {snoozeOpen ? (
          <div className="msg-snooze-menu" role="menu">
            {snoozePresets.map((p) => (
              <button
                key={p.id}
                type="button"
                className="msg-snooze-item"
                role="menuitem"
                onClick={() => onSnoozePick(p.wakeAt)}
              >
                {p.label}
              </button>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
